import React, { Component } from 'react';
import { connect } from 'react-redux';

import Loader from 'components/shared/Loader';
import MyForm from 'components/shared/form/MyForm';
import { required, email } from 'misc/validations';
import InputField from 'components/shared/form/InputField';
import { getText } from 'misc/helpers';
import * as types from 'misc/types';
import GovernmentCheckbox from '../../settings/GovernmentCheckbox';
import { GOVERNMENT_STATUS } from '../../../sagas/government';

class Government extends Component {
    render = () => {
        const { customer, government_status, government_list } = this.props;

        let connectData = {
            email: customer.data.email
        };

        let checkBoxes = [];

        if (government_status.data && government_status.data.type === GOVERNMENT_STATUS.REGISTERED) {
            if (government_list.data) {
                checkBoxes = government_list.data;
            }
        }

        return (
            <Loader objectToLoad={government_status}>
                {!government_status.isLoading && (
                    <div className="settings-view">
                        <h1>{getText('_10_2_Titel_authority_change', 'Myndighetspost')}</h1>
                        <p>
                            {getText(
                                '_10_2_Text_authority_change',
                                'Här kan du se/ändra vilka myndigheter och kommuner som kan skicka post till dig.'
                            )}
                        </p>
                        {government_status.data && government_status.data.type === GOVERNMENT_STATUS.REGISTERED ? (
                            <form
                                onSubmit={event => {
                                    event.preventDefault();
                                    this.onSubmit(checkBoxes);
                                    return false;
                                }}
                            >
                                <div className="settings-grid">
                                    {checkBoxes.map(government => (
                                        <GovernmentCheckbox {...government} checkMethod={e => this.onCheckBox(e, checkBoxes)} />
                                    ))}
                                </div>
                                <button className="button-submit button-yellow button-big button-bankid" type="submit">
                                    {getText('_10_2_text_authority_canges_save', 'Spara')}
                                </button>
                                <p>
                                    <a className="government-end-link" onClick={e => this.endGovernment(e)}>
                                        {getText('_10_2_text_authority_canges_exit', 'Avsluta myndighetspost')}
                                    </a>
                                </p>
                            </form>
                        ) : (
                            <React.Fragment>
                                <MyForm
                                    name="GovernmentConnectForm"
                                    sagaAction={types.SAGA_GOVERNMENT_CONNECT_POST}
                                    initialValues={connectData}
                                    buttonClasses="button-yellow button-big button-bankid"
                                    submitLabel={getText('_10_0_text_authority_sign', 'Anslut')}
                                >
                                    <InputField
                                        name="email"
                                        type="text"
                                        validate={[required, email]}
                                        placeholder={getText('ProfileEmail', 'E-postadress')}
                                        noStartWarning
                                        icon="assets/images/settings/ico_email.svg"
                                    />
                                </MyForm>
                            </React.Fragment>
                        )}
                    </div>
                )}
            </Loader>
        );
    };

    onSubmit(checkBoxes) {
        const { dispatch } = this.props;

        dispatch({ type: types.SAGA_GOVERNMENT_LIST_PUT.REQUEST, checkboxes: checkBoxes });
    }

    onCheckBox(e, checkBoxes) {
        let checkBox = checkBoxes.find(checkBox => checkBox.id === e.target.id);
        checkBox.active = e.target.checked;
    }

    endGovernment(event) {
        event.preventDefault();
        const { dispatch } = this.props;

        dispatch({ type: types.SAGA_GOVERNMENT_CONNECT_DELETE.REQUEST });
    }

    componentDidMount() {
        // Get government connect status
        const { dispatch } = this.props;
        dispatch({ type: types.SAGA_GOVERNMENT_CONNECT_GET.REQUEST });
    }
}

// Check if customer has pending email or mobile phone
// and set the appropriate values to the input fields
const mapStateToProps = (state, ownProps) => {
    return {
        government_status: state.government_status,
        government_list: state.government_list,
        customer: state.customer,
        sessions: state.sessions
    };
};

export default connect(mapStateToProps)(Government);



// WEBPACK FOOTER //
// ./src/components/views/settings/Government.js